module.exports = __webpack_public_path__ + "img/Classroom.4a6b8810.png";